import React, { useEffect, useMemo, useState, useContext, useRef } from "react";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  MenuItem,
  Tabs,
  Tab,
  Box,
  Typography,
  Select,
  InputLabel,
  FormControl,
  Chip,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  IconButton,
  Checkbox,
  Divider,
  Tooltip,
  Paper,
  Grid,
  Radio,
  RadioGroup,
  FormControlLabel,
  InputAdornment
} from "@material-ui/core";
import { Autocomplete } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import { Delete as DeleteIcon, AccessTime, CheckCircle, Event as EventIcon, Edit as EditIcon } from "@material-ui/icons";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { toast } from "react-toastify";
import api from "../../services/api";
import ShowTicketOpen from "../ShowTicketOpenModal";
import {
  getTicketDetails,
  updateTicketDetails,
  listCategories,
  listCategoryFields,
  listAssignees,
  replaceAssignees,
  addAssignee,
  removeAssignee,
  listComments,
  addComment,
  removeComment,
  listChecklists,
  createChecklist,
  updateChecklist,
  deleteChecklist,
  addChecklistItem,
  updateChecklistItem,
  deleteChecklistItem,
  applyChecklistTemplate
} from "../../services/ticketExtras";
// Campos personalizados (categoria avançada)
import { listCustomCategoryFields } from "../../services/customCategoryFields";
import { listTemplates } from "../../services/checklistTemplates";
import { AuthContext } from "../../context/Auth/AuthContext";
import useCompanySettings from "../../hooks/useSettings/companySettings";
import { useTheme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  dialogContainer: {
    alignItems: "flex-start",
  },
  dialogPaper: {
    maxWidth: '1000px',
    width: '95%',
    height: '90vh',
    margin: theme.spacing(1),
    borderRadius: 16,
    overflow: 'hidden',
    background: (theme.palette.mode === 'light' || theme.palette.type === 'light')
      ? `linear-gradient(135deg, ${theme.palette.background.paper} 0%, ${theme.palette.background.default} 100%)`
      : `linear-gradient(135deg, ${theme.palette.background.paper} 0%, ${theme.palette.background.default} 100%)`,
  },
  dialogTitle: {
    background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
    color: theme.palette.primary.contrastText,
    padding: theme.spacing(1.5, 2),
    minHeight: 'auto',
    '& .MuiTypography-h6': {
      fontWeight: 600,
      fontSize: '1.1rem',
      display: 'flex',
      alignItems: 'center',
    }
  },
  tabsContainer: {
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    background: (theme.palette.mode === 'light' || theme.palette.type === 'light')
      ? 'rgba(255,255,255,0.8)'
      : 'rgba(0,0,0,0.2)',
    backdropFilter: 'blur(6px)'
  },
  dialogContent: {
    padding: theme.spacing(2),
    paddingTop: theme.spacing(1),
    display: 'flex',
    flexDirection: 'column',
    height: 'calc(90vh - 120px)'
  },
  tabPanel: {
    padding: theme.spacing(2),
    flex: 1,
    overflowY: 'auto',
    overflowX: 'hidden',
    '&::-webkit-scrollbar': { width: 8 },
    '&::-webkit-scrollbar-track': {
      background: (theme.palette.mode === 'light' || theme.palette.type === 'light')
        ? 'rgba(0,0,0,0.08)'
        : 'rgba(255,255,255,0.08)',
      borderRadius: 4,
    },
    '&::-webkit-scrollbar-thumb': {
      background: `linear-gradient(45deg, ${theme.palette.primary.main}, ${theme.palette.primary.dark})`,
      borderRadius: 4,
    },
  },
  styledTextField: {
    '& .MuiOutlinedInput-root': {
      borderRadius: 14,
      background: (theme.palette.mode === 'light' || theme.palette.type === 'light')
        ? 'rgba(255,255,255,0.95)'
        : 'rgba(255,255,255,0.06)',
      boxShadow: (theme.palette.mode === 'light' || theme.palette.type === 'light')
        ? '0 1px 2px rgba(0,0,0,0.04)'
        : '0 1px 2px rgba(0,0,0,0.35)',
      '& fieldset': { borderColor: theme.palette.divider, borderWidth: 1 },
      '&:hover fieldset': { borderColor: theme.palette.primary.light },
      '&.Mui-focused fieldset': { borderColor: theme.palette.primary.main, boxShadow: `0 0 0 3px ${theme.palette.primary.main}22` },
    },
    '& .MuiOutlinedInput-input': {
      paddingTop: 12,
      paddingBottom: 12,
    },
    '& .MuiInputLabel-outlined': {
      transform: 'translate(14px, 14px) scale(1)',
    },
    '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
      transform: 'translate(14px, -6px) scale(0.85)'
    }
  },
  outlinedControl: {
    '& .MuiOutlinedInput-root': {
      borderRadius: 14,
      background: (theme.palette.mode === 'light' || theme.palette.type === 'light')
        ? 'rgba(255,255,255,0.95)'
        : 'rgba(255,255,255,0.06)',
      boxShadow: (theme.palette.mode === 'light' || theme.palette.type === 'light')
        ? '0 1px 2px rgba(0,0,0,0.04)'
        : '0 1px 2px rgba(0,0,0,0.35)',
      '& fieldset': { borderColor: theme.palette.divider, borderWidth: 1 },
      '&:hover fieldset': { borderColor: theme.palette.primary.light },
      '&.Mui-focused fieldset': { borderColor: theme.palette.primary.main, boxShadow: `0 0 0 3px ${theme.palette.primary.main}22` },
    }
  },
  panelPaper: {
  padding: theme.spacing(0, 1.5),
  borderRadius: 14,
    border: `1px solid ${theme.palette.divider}`,
    background: (theme.palette.type === 'dark' || theme.palette.mode === 'dark')
      ? 'rgba(0,0,0,0.25)'
      : '#FFFFFF',
    position: 'relative'
  },
  panelLegend: {
  position: 'absolute',
  top: -10,
  left: 14,
    padding: '0 6px',
    fontSize: '0.75rem',
    lineHeight: 1,
    color: theme.palette.text.secondary,
    background: (theme.palette.type === 'dark' || theme.palette.mode === 'dark')
      ? 'rgba(0,0,0,0.25)'
      : '#FFFFFF',
    pointerEvents: 'none'
  },
  priorityPaper: {
    height: 'auto',
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1.5),
    boxSizing: 'border-box',
    overflow: 'visible'
  },
  priorityControl: {
  margin: 0,
  padding: 0,
  width: '100%',
  height: '100%',
  display: 'flex',
  alignItems: 'center'
  },
  denseLike: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1)
  },
  bigTextArea: {
    '& .MuiOutlinedInput-root': {
      borderRadius: 16,
    },
    '& textarea.MuiOutlinedInput-inputMultiline': {
      padding: '12px 14px',
      minHeight: 120,
      lineHeight: 1.5
    }
  },
  priorityGroup: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
  height: '100%',
  marginTop: 0,
  marginBottom: 0,
    // reduzir espaçamento entre opções
    '& .MuiFormControlLabel-root': {
      marginLeft: 0,
      marginRight: theme.spacing(1.5),
      marginTop: 0,
  marginBottom: 0,
  paddingTop: 9,
  paddingBottom: 9,
  minHeight: 0,
  alignItems: 'center'
    },
    '& .MuiFormControlLabel-label': {
  lineHeight: 1,
  padding: 0
    },
    '& .MuiRadio-root': {
  paddingTop: 2,
  paddingBottom: 2,
  margin: 0
    },
    [theme.breakpoints.up('md')]: {
      flexWrap: 'nowrap'
    }
  },
  // --- Comentários ---
  commentList: {
    marginTop: theme.spacing(2),
  },
  commentCard: {
    position: 'relative',
    display: 'flex',
    alignItems: 'flex-start',
    padding: theme.spacing(1.25, 1.5),
    borderRadius: 12,
    border: `1px solid ${theme.palette.divider}`,
    background: (theme.palette.type === 'dark' || theme.palette.mode === 'dark') ? 'rgba(255,255,255,0.05)' : '#FFFFFF',
    boxShadow: (theme.palette.type === 'dark' || theme.palette.mode === 'dark') ? '0 1px 2px rgba(0,0,0,0.6)' : '0 1px 2px rgba(0,0,0,0.08)',
    marginBottom: theme.spacing(1.25),
    transition: 'background .2s, box-shadow .2s',
    '&:hover': {
      background: (theme.palette.type === 'dark' || theme.palette.mode === 'dark') ? 'rgba(255,255,255,0.08)' : 'rgba(250,250,250,0.7)',
      '& $commentActions': { opacity: 1, transform: 'translateY(0)' }
    }
  },
  commentCardInternal: {
    borderLeft: `4px solid ${theme.palette.warning.main}`,
    background: (theme.palette.type === 'dark' || theme.palette.mode === 'dark') ? 'rgba(255,193,7,0.08)' : '#FFFDF4'
  },
  commentAvatar: {
    width: 34,
    height: 34,
    flex: '0 0 34px',
    borderRadius: '50%',
    background: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    fontSize: '0.85rem',
    fontWeight: 600,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: theme.spacing(1.5),
    userSelect: 'none'
  },
  commentBody: {
    flex: 1,
    minWidth: 0
  },
  commentHeader: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
    marginBottom: 2
  },
  commentName: {
    fontWeight: 600,
    fontSize: '0.85rem'
  },
  commentTimestamp: {
    fontSize: '0.68rem',
    color: theme.palette.text.secondary,
    fontWeight: 400
  },
  commentEdited: {
    fontSize: '0.6rem',
    color: theme.palette.text.secondary,
    textTransform: 'uppercase',
    letterSpacing: 0.5
  },
  commentInternalChip: {
    height: 18,
    fontSize: '0.6rem',
    fontWeight: 600,
    background: theme.palette.warning.main,
    color: theme.palette.getContrastText(theme.palette.warning.main)
  },
  commentMessage: {
    fontSize: '0.78rem',
    lineHeight: 1.5,
    whiteSpace: 'pre-line',
    wordBreak: 'break-word'
  },
  commentActions: {
    position: 'absolute',
    top: 4,
    right: 4,
    display: 'flex',
    gap: 4,
    opacity: 0,
    transform: 'translateY(-4px)',
    transition: 'opacity .2s, transform .2s'
  },
  commentEditArea: {
    marginTop: theme.spacing(1)
  },
  commentNewContainer: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 12,
    padding: theme.spacing(1.5),
    marginBottom: theme.spacing(2),
    background: (theme.palette.type === 'dark' || theme.palette.mode === 'dark') ? 'rgba(255,255,255,0.05)' : '#FFFFFF'
  },
  commentNewActions: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: theme.spacing(1)
  },
  // Chip do contato travado (usar cor do tema)
  contactChip: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    fontWeight: 700,
  },
  // Banner e destaque laranja para recursos bloqueados (Kanban Avançado)
  lockedBanner: {
    borderRadius: 10,
    padding: theme.spacing(1.25),
    background: `${(theme.palette.warning.main)}22`,
    border: `1px dashed ${(theme.palette.warning.main)}66`,
    color: theme.palette.warning.dark,
  },
  lockedField: {
    '& .MuiOutlinedInput-root': {
      background: `${(theme.palette.warning.main)}0A`,
    },
    '& .MuiOutlinedInput-root fieldset': {
      borderColor: `${(theme.palette.warning.main)}80 !important`,
    },
    '& .MuiInputLabel-outlined': {
      color: `${(theme.palette.warning.main)}CC`,
    }
  },
  lockedPanel: {
    border: `1px solid ${(theme.palette.warning.main)}66`,
    background: `${(theme.palette.warning.main)}0A`
  },
}));

// Estilos adicionais para o cabeçalho do checklist (barra colorida)
const useChecklistHeaderStyles = makeStyles((theme) => ({
  checklistHeader: {
    background: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    padding: theme.spacing(1, 1.5),
    borderRadius: 10,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  checklistHeaderTitle: {
    fontWeight: 600,
    color: 'inherit'
  },
  checklistHeaderChip: {
    background: 'rgba(255,255,255,0.18)',
    color: 'inherit',
    height: 22
  }
}));

const priorities = [
  { value: 0, label: "Baixa" },
  { value: 1, label: "Média" },
  { value: 2, label: "Alta" }
];

const TicketDetailsModal = ({ open, onClose, ticketId, onSaved, initialContact = null, lockContact = false }) => {
  const classes = useStyles();
  const headerClasses = useChecklistHeaderStyles();
  const theme = useTheme();
  const history = useHistory();
  const isDark = (theme.palette.type === 'dark') || (theme.palette.mode === 'dark');
  const { get: getCompanySetting } = useCompanySettings();
  const { user, socket } = useContext(AuthContext);
  const [planAdvanced, setPlanAdvanced] = useState(
    user?.company?.plan?.useKanbanAdvanced || user?.plan?.useKanbanAdvanced || user?.useKanbanAdvanced || false
  );
  const [manualTicketCreationEnabled, setManualTicketCreationEnabled] = useState(false);
  const [settingsLoaded, setSettingsLoaded] = useState(false);

  const subjectRef = useRef(null);
  const priorityRef = useRef(null);
  const [priorityHeight, setPriorityHeight] = useState(null);
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({ subject: "", description: "", categoryId: "", dueDate: "", priority: 1 });
  // Guarda o estado original do dueDate para detectar limpeza explícita na edição
  const [origDueDate, setOrigDueDate] = useState("");
  const [persistedCategoryId, setPersistedCategoryId] = useState(null);
  const [categories, setCategories] = useState([]);
  const [fields, setFields] = useState([]); // legacy
  const [fieldValues, setFieldValues] = useState({});
  const [errors, setErrors] = useState({}); // { fieldId: message }
  // Custom category fields (novos)
  const [customFields, setCustomFields] = useState([]);
  const [customFieldValues, setCustomFieldValues] = useState({});
  const [customFieldErrors, setCustomFieldErrors] = useState({});
  const [tab, setTab] = useState(0); // 0 Detalhes, 1 Assignees, 2 Comentários, 3 Checklist
  const [services, setServices] = useState([]);

  // Info do contato do ticket (exibição no topo quando bloqueado)
  const [contactInfo, setContactInfo] = useState(null);

  // Assignees
  const [allUsers, setAllUsers] = useState([]);
  const [assignees, setAssignees] = useState([]); // array de userIds
  const [savingAssignees, setSavingAssignees] = useState(false);

  // Comments
  const [comments, setComments] = useState([]);
  const [newComment, setNewComment] = useState("");
  const [newCommentInternal, setNewCommentInternal] = useState(false);
  const [editingCommentId, setEditingCommentId] = useState(null);
  const [editingCommentText, setEditingCommentText] = useState("");
  const [editingCommentInternal, setEditingCommentInternal] = useState(false);
  
  const [loadingComments, setLoadingComments] = useState(false);
  // removido: redeclaração de user; já declarado acima com socket

  // Checklist
  const [checklists, setChecklists] = useState([]);
  const [newChecklistTitle, setNewChecklistTitle] = useState("");
  const [loadingChecklists, setLoadingChecklists] = useState(false);
  const [templates, setTemplates] = useState([]);
  // Edição inline de títulos (itens e cabeçalho do checklist)
  const [editingItemId, setEditingItemId] = useState(null);
  const [editingItemTitle, setEditingItemTitle] = useState("");
  const [editingChecklistId, setEditingChecklistId] = useState(null);
  const [editingChecklistTitle, setEditingChecklistTitle] = useState("");
  // Controle local para exibição de editor de nova descrição em itens que não possuem
  const [addingDescriptionFor, setAddingDescriptionFor] = useState({}); // { itemId: true }
  // Conflito de ticket já em atendimento
  const [openAlert, setOpenAlert] = useState(false);
  const [userTicketOpen, setUserTicketOpen] = useState("");
  const [queueTicketOpen, setQueueTicketOpen] = useState("");
  // Criação: busca/seleção de contato
  const [contactSearch, setContactSearch] = useState("");
  const [contactOptions, setContactOptions] = useState([]);
  const [contactLoading, setContactLoading] = useState(false);
  const [selectedContact, setSelectedContact] = useState(null); // objeto contato

  // Estado de workflow (active/done/archived) e flag readOnly
  const [workflowState, setWorkflowState] = useState('active');
  const [ticketTags, setTicketTags] = useState([]);
  const readOnly = workflowState !== 'active';
  // Bloqueio por plano/config: Tickets Avançados
  const advancedLocked = (!planAdvanced) || (planAdvanced && settingsLoaded && !manualTicketCreationEnabled);
  const bannerText = !planAdvanced
    ? "Recursos avançados do Kanban não fazem parte do seu plano."
    : (!manualTicketCreationEnabled ? "Recursos avançados do Kanban estão desativados nas configurações da empresa." : "");
  // Há ticket válido para operações das abas secundárias?
  const hasTicket = Number.isFinite(Number(ticketId)) && Number(ticketId) > 0;

  // Carrega flag de criação manual e assina atualizações do plano/config
  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const setting = await getCompanySetting({ column: "manualTicketCreation", noCache: true });
        if (!mounted) return;
        setManualTicketCreationEnabled(setting?.manualTicketCreation === "enabled");
        setSettingsLoaded(true);
      } catch {
        if (mounted) {
          setManualTicketCreationEnabled(false);
          setSettingsLoaded(true);
        }
      }
    })();
    return () => { mounted = false; };
  }, [getCompanySetting, user?.companyId]);

  useEffect(() => {
    const companyId = user?.companyId;
    if (!companyId || !socket) return;
    const onCompanySettings = (data) => {
      if (data?.action !== "update") return;
      if (data?.setting?.key === "manualTicketCreation") {
        setManualTicketCreationEnabled(data?.setting?.value === "enabled");
        setSettingsLoaded(true);
      }
    };
    const onPlan = (data) => {
      if (data?.action !== "update") return;
      const useAdv = Boolean(data?.plan?.useKanbanAdvanced);
      setPlanAdvanced(useAdv);
    };
    const chSettings = `company-${companyId}-companySettings`;
    const chPlan = `company-${companyId}-plan`;
    socket.on(chSettings, onCompanySettings);
    socket.on(chPlan, onPlan);
    return () => {
      socket.off(chSettings, onCompanySettings);
      socket.off(chPlan, onPlan);
    };
  }, [socket, user?.companyId]);

  // Campos que devem ser exibidos em multilinha (heurística por nome)
  const MULTILINE_FIELD_NAMES = useMemo(() => (
    [
      "Passos reproduzíveis",
      "Passos reproduziveis",
      "Observações",
      "Observacoes",
      "Plano de ação",
      "Plano de acao",
      "Objetivos do cliente",
      "Escopo",
      "Entregáveis",
      "Entregaveis",
      "Requisitos",
      "Ambiente/URLs",
      "Ambiente",
      "URLs",
      "Datasets",
      "Descrição",
      "Descricao"
    ]
  ), []);

  // Campos multiline que devem ter altura maior (mesmo número de linhas da Descrição)
  const LARGE_MULTILINE_FIELD_NAMES = useMemo(() => (
    ["Escopo"]
  ), []);

  // campos a ocultar globalmente por key/name
  const HIDDEN_FIELD_KEYS = useMemo(() => {
    const list = [
      'marco_proximo', 'marco proximo', 'marco-próximo', 'marco-proximo',
      'dependencias', 'dependências', 'dependencia', 'dependência', 'dependencies',
      'go_line', 'go-live', 'go live', 'golive', 'go_line', 'go_line_date', 'go_live',
      'times', 'equipes', 'teams',
      'datasets', 'data_sets', 'data sets',
      'subcategoria', 'sub_category', 'subcategoria_impl',
      'contatos', 'contacts',
      'proximo_passo', 'próximo_passo', 'proximo passo', 'próximo passo', 'next_step'
    ];
    return new Set(list.map(s => String(s).toLowerCase()));
  }, []);

  const shouldHideField = (f) => {
    const key = String(f?.key ?? '').toLowerCase();
    const name = String(f?.name ?? '').toLowerCase();
    if (!key && !name) return false;
    return HIDDEN_FIELD_KEYS.has(key) || HIDDEN_FIELD_KEYS.has(name);
  };

  // Normalizador e ordenação dos campos (Ambiente -> Tipo -> Severidade -> Impacto)
  const normalizeKey = (s) => String(s || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  const sortedFields = useMemo(() => {
    const arr = (fields || []).slice();
    const isRisk = (f) => {
      const k = normalizeKey(f.key || f.name);
      return k.includes('riscos') || k.includes('risco');
    };
    const isBudgetHours = (f) => {
      const k = normalizeKey(f.key || f.name);
      const hasBudget = k.includes('orcamento') || k.includes('orçamento');
      const hasHours = k.includes('hora');
      return hasBudget && hasHours;
    };
    const isSatisfaction = (f) => {
      const k = normalizeKey(f.key || f.name);
      return k.includes('satisf'); // cobre satisfacao/satisfação
    };
    const isNps = (f) => {
      const k = normalizeKey(f.key || f.name);
      return k.includes('nps');
    };
    const isNextFollowUp = (f) => {
      const k = normalizeKey(f.key || f.name);
      return (k.includes('proximo') || k.includes('prox')) && (k.includes('follow') || k.includes('retorno'));
    };
    const isMotivo = (f) => {
      const k = normalizeKey(f.key || f.name);
      return k.includes('motivo') || k.includes('reason');
    };
    return arr.sort((a, b) => {
      const ka = normalizeKey(a.key || a.name);
      const kb = normalizeKey(b.key || b.name);
      const isLocal = (k) => k.includes('local');
      const isSistemaModulo = (k) => k.includes('sistema') || k.includes('modulo') || k.includes('módulo');
      const isUrgencia = (k) => k.includes('urgenc');
      const isVersaoBuild = (k) => (
        k.includes('versao') || k.includes('versão') || k.includes('build') || k.includes('release')
      );
      const isAtivoEquip = (k) => (
        k.includes('ativo') || k.includes('equipamento') || k.includes('asset') || k.includes('device')
      );
      const isNumeroSerie = (k) => (
        k.includes('serial') || ((k.includes('numero') || k.includes('nº') || k.includes('n°')) && k.includes('serie'))
      );
      // Define a ordem de exibição por prioridade simples para montar linhas:
      // 1ª linha: Ambiente, Tipo, Severidade, Impacto (4 colunas)
      // 2ª linha: Local, Sistema/Módulo, Urgência (3 colunas)
      const rank = (k) => {
        if (k.includes('ambiente')) return 10;
        if (k.includes('tipo')) return 20;
        if (k.includes('severidade') || k.includes('severity')) return 30;
        if (k.includes('impacto') || k.includes('impact')) return 40;
  if (isLocal(k)) return 50;
  if (isSistemaModulo(k)) return 60;
  // 2ª linha: Nº de série (70), Versão/Build(80), Ativo/Equipamento(90)
  if (isNumeroSerie(k)) return 70;
  if (isVersaoBuild(k)) return 80;
  if (isAtivoEquip(k)) return 90;
        return 1000;
      };
      // Empurra campos de Riscos e Orçamentos de horas para o final
      const endA = isRisk(a) || isBudgetHours(a) || isSatisfaction(a) || isNps(a) || isNextFollowUp(a) || isMotivo(a);
      const endB = isRisk(b) || isBudgetHours(b) || isSatisfaction(b) || isNps(b) || isNextFollowUp(b) || isMotivo(b);
      const ra = endA ? 100000 : rank(ka);
      const rb = endB ? 100000 : rank(kb);
      if (ra !== rb) return ra - rb;
      const oa = (typeof a.order === 'number') ? a.order : arr.indexOf(a);
      const ob = (typeof b.order === 'number') ? b.order : arr.indexOf(b);
      return oa - ob;
    });
  }, [fields]);

  useEffect(() => {
    if (!open) return;
    if (!ticketId) {
      // Modo criação: carregar categorias, serviços globais e usuários
      (async () => {
        setLoading(true);
        try {
          const [{ data: cats }, { data: userRes }] = await Promise.all([
            listCategories(),
            api.get("/users")
          ]);
          setCategories(cats || []);
          // serviços globais
          try {
            const { data: svc } = await api.get(`/service-catalog`);
            setServices(Array.isArray(svc) ? svc : []);
          } catch {}
          const usersArray = (userRes && (userRes.users || (Array.isArray(userRes) ? userRes : []))) || [];
          setAllUsers(usersArray);
          setAssignees([]);
          setFields([]);
          setFieldValues({});
          setPersistedCategoryId(null);
          // Se vier contato pré-definido, mostrar bloqueado no topo e ajustar seleção interna
          if (initialContact && initialContact.id) {
            setContactInfo({ name: initialContact.name, number: initialContact.number });
            setSelectedContact({ id: initialContact.id, name: initialContact.name, number: initialContact.number });
            setContactSearch(initialContact.name || initialContact.number || "");
          } else {
            setContactInfo(null);
            setSelectedContact(null);
            setContactSearch("");
          }
        } finally {
          setLoading(false);
        }
      })();
      return;
    }
    (async () => {
      setLoading(true);
      try {
  const [{ data: det }, { data: cats }, { data: userRes }, { data: asg }] = await Promise.all([
          getTicketDetails(ticketId),
          listCategories(),
          api.get("/users"),
          listAssignees(ticketId)
        ]);
  const ws = det?.ticket?.workflowState;
  setWorkflowState(ws === 'done' || ws === 'archived' || ws === 'active' ? ws : 'active');
  setTicketTags(Array.isArray(det?.ticket?.tags) ? det.ticket.tags : []);
  // Normaliza dueDate para o input datetime-local (YYYY-MM-DDTHH:mm) convertendo para horário local quando vier com timezone
  try {
    const raw = det.ticket.dueDate ? String(det.ticket.dueDate) : "";
    const toLocalDateTimeInput = (s) => {
      const str = String(s || "").trim();
      if (!str) return "";
      // Se possuir timezone explícito (Z ou ±HH:MM), converter para local
      if (/[Zz]$|[+-]\d{2}:\d{2}$/.test(str)) {
        const d = new Date(str);
        if (!isNaN(d.getTime())) {
          const pad = (n) => String(n).padStart(2, "0");
          const yyyy = d.getFullYear();
          const MM = pad(d.getMonth() + 1);
          const dd = pad(d.getDate());
          const HH = pad(d.getHours());
          const mm = pad(d.getMinutes());
          return `${yyyy}-${MM}-${dd}T${HH}:${mm}`;
        }
      }
      // Sem timezone: aceitar diretamente YYYY-MM-DDTHH:mm
      const m = str.match(/^(\d{4}-\d{2}-\d{2})(?:T(\d{2}:\d{2}))/);
      if (m && m[1]) return `${m[1]}T${m[2]}`;
      // Apenas data: completar com 00:00
      if (/^\d{4}-\d{2}-\d{2}$/.test(str)) return `${str}T00:00`;
      return "";
    };
    const dt = toLocalDateTimeInput(raw);
    setForm({
      subject: det.ticket.subject || "",
      description: det.ticket.description || "",
      categoryId: det.ticket.categoryId || "",
      dueDate: dt,
      priority: det.ticket.priority ?? 1,
      serviceId: det.ticket.serviceId || ""
    });
  } catch {
    setForm({
      subject: det.ticket.subject || "",
      description: det.ticket.description || "",
      categoryId: det.ticket.categoryId || "",
      dueDate: "",
      priority: det.ticket.priority ?? 1,
      serviceId: det.ticket.serviceId || ""
    });
  }
  setOrigDueDate(det.ticket.dueDate ? String(det.ticket.dueDate).slice(0, 10) : "");
  setContactInfo(det.ticket?.contact ? { name: det.ticket.contact.name, number: det.ticket.contact.number } : null);
        setPersistedCategoryId(det.ticket.categoryId ?? null);
        const initialMap = {};
        (det.fieldValues || []).forEach(fv => { initialMap[fv.fieldId] = fv.value; });
  setFieldValues(initialMap);
  // custom fields coletados já no endpoint de detalhes
  const cfArr = Array.isArray(det.customFields) ? det.customFields : [];
  setCustomFields(cfArr);
  const cfMap = {};
  cfArr.forEach(c => { cfMap[c.id] = c.value; });
  setCustomFieldValues(cfMap);
        if (det.ticket.categoryId) {
          const { data: fs } = await listCategoryFields(det.ticket.categoryId);
          // Oculta campos indesejados globalmente
          const filtered = (fs || []).filter((f) => !shouldHideField(f));
          setFields(filtered);
        } else {
          setFields([]);
        }
        // Carregar serviços (globais + da categoria)
        try {
          const cid = det.ticket.categoryId || "";
          const { data: svc } = await api.get(`/service-catalog`, { params: cid ? { categoryId: cid } : {} });
          setServices(Array.isArray(svc) ? svc : []);
        } catch {}
        setCategories(cats);
        // carregar usuários/atribuídos para exibir no Detalhes
        const usersArray = (userRes && (userRes.users || (Array.isArray(userRes) ? userRes : []))) || [];
        setAllUsers(usersArray);
        const assigned = Array.isArray(asg) ? asg : (asg && asg.items) ? asg.items : [];
        setAssignees((assigned || []).map(u => u.userId));
  // Reset abas secundárias
  setTab(0);
      } finally {
        setLoading(false);
      }
    })();
  }, [open, ticketId]);

  // Busca contatos para criação (ignora grupos)
  useEffect(() => {
    if (!open || ticketId) return; // somente criação
    // Se contato está travado, não pesquisar
    if (lockContact && initialContact && initialContact.id) {
      setContactOptions([]);
      setContactLoading(false);
      return;
    }
    const term = (contactSearch || "").trim();
    if (term.length < 3) { setContactOptions([]); setContactLoading(false); return; }
    setContactLoading(true);
    const t = setTimeout(async () => {
      try {
        const { data } = await api.get("/contacts", { params: { searchParam: term } });
        const list = (data?.contacts || []).filter(c => !c.isGroup);
        setContactOptions(list);
      } catch {
        setContactOptions([]);
      } finally {
        setContactLoading(false);
      }
    }, 400);
    return () => clearTimeout(t);
  }, [open, ticketId, contactSearch, lockContact, initialContact]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  // Sincroniza a altura do bloco de prioridade com o campo Assunto
  useEffect(() => {
    const el = subjectRef.current;
    const pr = priorityRef.current;
    if (!el || !pr) return;
    const apply = () => {
      const h = el.getBoundingClientRect().height;
      if (h && Math.abs(h - (priorityHeight || 0)) > 0.5) {
        setPriorityHeight(h);
      }
    };
    apply();
    const ro = new ResizeObserver(apply);
    ro.observe(el);
    return () => {
      try { ro.disconnect(); } catch {}
    };
  }, [subjectRef, priorityRef, priorityHeight]);

  const handleCategoryChange = async (e) => {
    const value = e.target.value;
    setForm(prev => ({ ...prev, categoryId: value }));
    // Reset erros
    setErrors({});
    setCustomFieldErrors({});
    setCustomFieldValues({});
    if (value) {
      try {
        // Campos legados
        const { data: legacy } = await listCategoryFields(value);
        setFields((legacy || []).filter((f) => !shouldHideField(f)));
      } catch { setFields([]); }
      try {
        // Carrega campos personalizados da nova categoria imediatamente
        const { data: cfs } = await listCustomCategoryFields(value);
        const arr = Array.isArray(cfs) ? cfs.filter(cf => cf && typeof cf === 'object') : [];
        setCustomFields(arr);
        const map = {};
        arr.forEach(cf => { if (cf && cf.id) map[cf.id] = cf.value; });
        setCustomFieldValues(map);
      } catch { setCustomFields([]); }
      try {
        const { data: svc } = await api.get(`/service-catalog`, { params: { categoryId: value } });
        setServices(Array.isArray(svc) ? svc : []);
      } catch {}
    } else {
      setFields([]);
      setCustomFields([]);
      try {
        const { data: svc } = await api.get(`/service-catalog`);
        setServices(Array.isArray(svc) ? svc : []);
      } catch {}
    }
  };

  const handleFieldValueChange = (id, value) => {
    setFieldValues(prev => ({ ...prev, [id]: value }));
  };

  const validateLocal = () => {
    const nextErrors = {};
    const nextCustomErrors = {};
    const isEmpty = (v) => v === null || v === undefined || v === "";
    for (const f of fields) {
      const val = fieldValues[f.id];
      const type = f.type || "text";
      if (f.required) {
        if (type === "bool" || type === "boolean") {
          if (val === null || val === undefined) nextErrors[f.id] = "Obrigatório";
        } else if (type === "multiselect") {
          if (!Array.isArray(val) || val.length === 0) nextErrors[f.id] = "Obrigatório";
        } else if (isEmpty(val)) {
          nextErrors[f.id] = "Obrigatório";
        }
      }
      if (!isEmpty(val)) {
        if (type === "number") {
          if (Number.isNaN(Number(val))) nextErrors[f.id] = "Número inválido";
        } else if (type === "date") {
          if (Number.isNaN(new Date(val).getTime())) nextErrors[f.id] = "Data inválida";
        } else if (type === "select") {
          const opts = (f.options || []).map((o) => typeof o === "object" && o !== null ? String(o.value ?? o.label ?? "") : String(o));
          if (opts.length && !opts.includes(String(val))) nextErrors[f.id] = "Opção inválida";
        } else if (type === "multiselect") {
          const opts = (f.options || []).map((o) => typeof o === "object" && o !== null ? String(o.value ?? o.label ?? "") : String(o));
          if (!Array.isArray(val) || (opts.length && val.some((r) => !opts.includes(String(r)))) ) nextErrors[f.id] = "Opção inválida";
        }
      }
    }
    setErrors(nextErrors);
    // valida custom
    customFields.forEach(cf => {
      if (!cf) return;
      const raw = customFieldValues[cf.id];
      if (cf.required) {
        if (cf.type === 'yes_no' || cf.type === 'checkbox') {
          if (typeof raw === 'undefined' || raw === null) nextCustomErrors[cf.id] = 'Obrigatório';
        } else if (raw === null || typeof raw === 'undefined' || raw === '') {
          nextCustomErrors[cf.id] = 'Obrigatório';
        }
      }
      if (raw != null && raw !== '') {
        if (cf.type === 'short_text' && String(raw).length > 60) nextCustomErrors[cf.id] = 'Máx 60';
        if (cf.type === 'long_text' && String(raw).length > 500) nextCustomErrors[cf.id] = 'Máx 500';
        if ((cf.type === 'yes_no' || cf.type === 'checkbox') && typeof raw !== 'boolean') nextCustomErrors[cf.id] = 'Valor inválido';
      }
    });
    setCustomFieldErrors(nextCustomErrors);
    return Object.keys(nextErrors).length === 0 && Object.keys(nextCustomErrors).length === 0;
  };

  const handleSave = async () => {
    // validação local
    if (!validateLocal()) return;
    setLoading(true);
    try {
      const clamp = (n, min, max) => Math.max(min, Math.min(max, n));
      const sanitized = {
        subject: form.subject,
        description: form.description,
        categoryId: form.categoryId === "" || form.categoryId == null ? null : Number(form.categoryId),
        // dueDate será tratado abaixo para evitar sobrescrever o preenchimento automático
        priority: Number.isFinite(Number(form.priority)) ? clamp(Number(form.priority), 0, 2) : 1
      };
      const visibleFieldIds = new Set((fields || []).map(f => Number(f.id)));
      const payload = {
        ticket: { ...sanitized },
        fieldValues: Object.entries(fieldValues)
          .filter(([fieldId]) => visibleFieldIds.has(Number(fieldId)))
          .map(([fieldId, value]) => ({ fieldId: Number(fieldId), value }))
      };

      // Regras para dueDate com datetime-local:
      // - Criação: se vazio, não enviar (SLA pode preencher automaticamente)
      // - Edição: enviar null somente se havia data original e o usuário limpou
      // - Se preenchido, enviar exatamente YYYY-MM-DDTHH:mm
      const normalizeOut = (v) => {
        const s = (v || "").trim();
        if (!s) return "";
        // aceita somente padrão YYYY-MM-DDTHH:mm
        const m = s.match(/^(\d{4}-\d{2}-\d{2})T(\d{2}:\d{2})$/);
        return m ? `${m[1]}T${m[2]}` : "";
      };
      if (!ticketId) {
        const out = normalizeOut(form.dueDate);
        if (out) payload.ticket.dueDate = out;
      } else {
        const out = normalizeOut(form.dueDate);
        if (out) {
          payload.ticket.dueDate = out;
        } else if (!form.dueDate && origDueDate) {
          payload.ticket.dueDate = null;
        }
      }
      // customFieldValues: enviar campos ativos ou inativos que já possuem valor
      const customPayload = {};
      customFields.forEach(cf => {
        const val = customFieldValues[cf.id];
        if (cf.active || (typeof val !== 'undefined' && val !== null && val !== '')) {
          customPayload[cf.id] = val;
        }
      });
      if (Object.keys(customPayload).length) payload.customFieldValues = customPayload;
      // inclui serviceId se presente no form
      payload.ticket.serviceId = form.serviceId === "" || form.serviceId == null ? null : Number(form.serviceId);

      if (!ticketId) {
        // criação: exige contato selecionado
        const cId = (lockContact && initialContact?.id) ? initialContact.id : selectedContact?.id;
        if (!cId) {
          toast.error("Selecione um contato para criar o ticket");
          setLoading(false);
          return;
        }
        // cria ticket oficial sem abrir conversa
        try {
          const { data: created } = await api.post("/tickets", {
            contactId: cId,
            status: "open",
            userId: user?.id || null,
            queueId: null,
            whatsappId: "",
            subject: sanitized.subject || null,
            forceOfficial: true
          });
          // Se recursos avançados estiverem bloqueados, não tente salvar detalhes avançados
          if (advancedLocked) {
            toast.success("Ticket criado");
            onSaved && onSaved(created?.uuid, created?.id);
            onClose && onClose();
            return;
          }
          // atualiza detalhes após criação (tolerante a falhas)
          try {
            await updateTicketDetails(created.id, payload);
            try { await replaceAssignees(created.id, assignees); } catch {}
            toast.success("Ticket criado");
            onSaved && onSaved(created?.uuid, created?.id);
            onClose && onClose();
            return;
          } catch (advErr) {
            // Se falhar apenas nos detalhes avançados, ainda assim fechar o modal
            toast.warn("Ticket criado, mas detalhes avançados não foram salvos.");
            onSaved && onSaved(created?.uuid, created?.id);
            onClose && onClose();
            return;
          }
        } catch (err) {
          // Conflito: ticket já existe aberto para este contato conforme regras do backend
          const raw = err?.response?.data?.error;
          if (raw && typeof raw === 'string') {
            try {
              const existing = JSON.parse(raw);
              if (existing?.userId && existing.userId !== user?.id) {
                setUserTicketOpen(existing?.user?.name || "Outro atendente");
                setQueueTicketOpen(existing?.queue?.name || "Fila");
                setOpenAlert(true);
                return;
              } else {
                // Ticket do próprio usuário: fechar modal e sinalizar caller para abrir o existente
                try {
                  if (existing?.uuid) {
                    history.push(`/tickets/${existing?.uuid}`);
                  } else {
                    history.push(`/tickets`);
                  }
                } catch {}
                onSaved && onSaved(existing?.uuid, existing?.id);
                onClose && onClose();
                return;
              }
            } catch {}
          }
          // Fallback: erro genérico (mantém tratamentos abaixo para erros 400 de validação)
          try { toast.error("Erro ao criar ticket."); } catch {}
          return;
        }
      }

      // atualização de ticket existente
  await updateTicketDetails(ticketId, payload);
      try { await replaceAssignees(ticketId, assignees); } catch {}
      setPersistedCategoryId(sanitized.categoryId ?? null);
      toast.success("Detalhes salvos");
      onSaved && onSaved();
      onClose();
    } catch (err) {
      // mapear erros 400 do backend
      if (err?.response?.status === 400) {
        if (err?.response?.data?.code === "CATEGORY_LOCKED") {
          toast.error(err.response.data?.message || "Categoria bloqueada");
        } else if (err?.response?.data?.errors) {
          const be = err.response.data.errors;
          const map = {};
          (be || []).forEach((e) => { if (e.fieldId) map[e.fieldId] = e.message || "Inválido"; });
          setErrors(map);
        } else if (err?.response?.data?.code === 'CUSTOM_FIELDS_VALIDATION_ERROR') {
          const errs = err?.response?.data?.errors || [];
          const cMap = {};
          errs.forEach(e => { if (e.fieldId) cMap[e.fieldId] = e.message || 'Inválido'; });
          setCustomFieldErrors(cMap);
        }
      }
    } finally {
      setLoading(false);
    }
  };

  const handleCloseAlert = () => {
    setOpenAlert(false);
    setUserTicketOpen("");
    setQueueTicketOpen("");
  };

  const renderCustomField = (cf) => {
    const value = customFieldValues[cf.id];
    const setVal = (v) => setCustomFieldValues(prev => ({ ...prev, [cf.id]: v }));
    const disabled = readOnly || advancedLocked || loading || (!cf.active && (value === null || typeof value === 'undefined' || value === ''));
    const error = !!customFieldErrors[cf.id];
    const helper = customFieldErrors[cf.id] ? customFieldErrors[cf.id] : (!cf.active ? 'Inativo' : ' ');
    if (cf.type === 'short_text') {
      return <TextField key={cf.id} fullWidth label={cf.name + (cf.required ? ' *' : '')} value={value || ''} disabled={disabled}
        variant="outlined" margin="dense"
        className={`${classes.styledTextField} ${advancedLocked ? classes.lockedField : ''}`}
        onChange={e => setVal(e.target.value)} error={error} helperText={helper} inputProps={{ maxLength: 60 }} />;
    }
    if (cf.type === 'long_text') {
      return <TextField key={cf.id} fullWidth multiline rows={3} label={cf.name + (cf.required ? ' *' : '')} value={value || ''} disabled={disabled}
        variant="outlined" margin="dense"
        className={`${classes.styledTextField} ${advancedLocked ? classes.lockedField : ''}`}
        onChange={e => setVal(e.target.value)} error={error} helperText={helper} inputProps={{ maxLength: 500 }} />;
    }
    if (cf.type === 'yes_no') {
      // RadioGroup Sim / Não (valor boolean interno)
      const radioVal = value === true ? 'yes' : value === false ? 'no' : '';
      return (
        <FormControl key={cf.id} component="fieldset" style={{ marginBottom: 12 }} disabled={disabled}>
          <Typography variant="caption" color="textSecondary" style={{ marginLeft: 2, marginBottom: 2 }}>
            {cf.name}{cf.required ? ' *' : ''}
          </Typography>
          <RadioGroup row value={radioVal} onChange={(e)=> setVal(e.target.value === 'yes')}>
            <FormControlLabel value="yes" control={<Radio color="primary" />} label="Sim" disabled={disabled} />
            <FormControlLabel value="no" control={<Radio color="primary" />} label="Não" disabled={disabled} />
          </RadioGroup>
          {error ? (
            <Typography variant="caption" style={{ color:'#f44336' }}>{helper}</Typography>
          ) : (helper && helper.trim() && helper !== ' ' ? <Typography variant="caption" color="textSecondary">{helper}</Typography> : null)}
        </FormControl>
      );
    }
    if (cf.type === 'checkbox') {
      return (
        <FormControlLabel
          key={cf.id}
          style={{ marginBottom: 4 }}
          control={<Checkbox color="primary" checked={!!value} disabled={disabled} onChange={e => setVal(e.target.checked)} />}
          label={cf.name + (cf.required ? ' *' : '')}
        />
      );
    }
    return null;
  };

  // Carregamento sob demanda por aba (1 = Comentários, 2 = Checklist)
  useEffect(() => {
    if (!open || !ticketId) return;
    if (tab === 1) {
      (async () => {
        try {
          setLoadingComments(true);
          const { data } = await listComments(ticketId, 1, 100);
          setComments((data && (data.items || [])) || []);
        } finally {
          setLoadingComments(false);
        }
      })();
    } else if (tab === 2) {
      (async () => {
        try {
          setLoadingChecklists(true);
          try {
            const { data } = await listTemplates();
            setTemplates(Array.isArray(data) ? data : []);
          } catch {}
          const { data } = await listChecklists(ticketId);
          const lists = (data && data.lists) || [];
          const items = (data && data.items) || [];
          const grouped = lists.map(l => ({
            ...l,
            items: items.filter(it => it.checklistId === l.id)
          }));
          setChecklists(grouped);
        } finally {
          setLoadingChecklists(false);
        }
      })();
    }
  }, [tab, open, ticketId]);

  // Assignees handlers
  const handleAssigneesChange = async (event) => {
    const value = event.target.value;
    setAssignees(value);
  };

  const persistAssignees = async () => {
    setSavingAssignees(true);
    try {
      await replaceAssignees(ticketId, assignees);
      toast.success("Responsáveis atualizados");
    } finally {
      setSavingAssignees(false);
    }
  };

  // Comments handlers
  const submitComment = async () => {
    if (!hasTicket) { toast.info("Crie o ticket antes de usar esta aba"); return; }
    if (!newComment.trim()) return;
    try {
      await addComment(ticketId, newComment.trim(), newCommentInternal);
      setNewComment("");
  const { data } = await listComments(ticketId, 1, 100);
  setComments((data && (data.items || [])) || []);
      toast.success("Comentário adicionado");
    } catch {}
  };

  const removeCommentById = async (commentId) => {
    if (!hasTicket) { toast.info("Crie o ticket antes de usar esta aba"); return; }
    try {
      await removeComment(ticketId, commentId);
      setComments((prev) => prev.filter((c) => c.id !== commentId));
    } catch {}
  };

  const beginEditComment = (c) => {
    if (!hasTicket) { toast.info("Crie o ticket antes de usar esta aba"); return; }
    setEditingCommentId(c.id);
    setEditingCommentText(c.message || "");
    setEditingCommentInternal(!!c.isInternal);
  };

  const cancelEditComment = () => {
    setEditingCommentId(null);
    setEditingCommentText("");
    setEditingCommentInternal(false);
  };

  const saveEditComment = async () => {
    if (!hasTicket) { toast.info("Crie o ticket antes de usar esta aba"); return; }
    const target = (comments || []).find((c) => c.id === editingCommentId);
    if (!target) return cancelEditComment();
    const msg = (editingCommentText || "").trim();
    if (!msg) return; // não salva vazio
    try {
      await api.put(`/tickets/${ticketId}/comments/${editingCommentId}`, { message: msg, isInternal: editingCommentInternal });
      const { data } = await listComments(ticketId, 1, 100);
      setComments((data && (data.items || [])) || []);
      cancelEditComment();
      toast.success("Comentário atualizado");
    } catch {}
  };

  // Checklist handlers
  const createNewChecklist = async () => {
    if (!hasTicket) { toast.info("Crie o ticket antes de usar esta aba"); return; }
    const title = newChecklistTitle.trim();
    if (!title) return;
    try {
      await createChecklist(ticketId, title);
      setNewChecklistTitle("");
  const { data } = await listChecklists(ticketId);
  const lists = (data && data.lists) || [];
  const items = (data && data.items) || [];
  const grouped = lists.map(l => ({ ...l, items: items.filter(it => it.checklistId === l.id) }));
  setChecklists(grouped);
    } catch {}
  };

  const toggleItemDone = async (item) => {
    if (!hasTicket) { toast.info("Crie o ticket antes de usar esta aba"); return; }
    try {
      await updateChecklistItem(item.id, { done: !item.done });
  const { data } = await listChecklists(ticketId);
  const lists = (data && data.lists) || [];
  const items = (data && data.items) || [];
  const grouped = lists.map(l => ({ ...l, items: items.filter(it => it.checklistId === l.id) }));
  setChecklists(grouped);
    } catch {}
  };

  const updateItemDueDate = async (item, dateStr) => {
    if (!hasTicket) { toast.info("Crie o ticket antes de usar esta aba"); return; }
    try {
      await updateChecklistItem(item.id, { dueDate: dateStr || null });
      const { data } = await listChecklists(ticketId);
      const lists = (data && data.lists) || [];
      const items = (data && data.items) || [];
      const grouped = lists.map(l => ({ ...l, items: items.filter(it => it.checklistId === l.id) }));
      setChecklists(grouped);
    } catch {}
  };

  const addItemToChecklist = async (checklistId, title) => {
    if (!hasTicket) { toast.info("Crie o ticket antes de usar esta aba"); return; }
    const t = (title || "").trim();
    if (!t) return;
    await addChecklistItem(checklistId, t);
  const { data } = await listChecklists(ticketId);
  const lists = (data && data.lists) || [];
  const items = (data && data.items) || [];
  const grouped = lists.map(l => ({ ...l, items: items.filter(it => it.checklistId === l.id) }));
  setChecklists(grouped);
  };

  const removeItem = async (itemId) => {
    if (!hasTicket) { toast.info("Crie o ticket antes de usar esta aba"); return; }
    await deleteChecklistItem(itemId);
  const { data } = await listChecklists(ticketId);
  const lists = (data && data.lists) || [];
  const items = (data && data.items) || [];
  const grouped = lists.map(l => ({ ...l, items: items.filter(it => it.checklistId === l.id) }));
  setChecklists(grouped);
  };

  const removeChecklistById = async (checklistId) => {
    if (!hasTicket) { toast.info("Crie o ticket antes de usar esta aba"); return; }
    await deleteChecklist(checklistId);
  const { data } = await listChecklists(ticketId);
  const lists = (data && data.lists) || [];
  const items = (data && data.items) || [];
  const grouped = lists.map(l => ({ ...l, items: items.filter(it => it.checklistId === l.id) }));
  setChecklists(grouped);
  };

  const saveItemTitle = async (itemId, value) => {
    if (!hasTicket) { toast.info("Crie o ticket antes de usar esta aba"); return; }
    const title = (value || "").trim();
    setEditingItemId(null);
    try {
      if (title) {
        await updateChecklistItem(itemId, { title });
        const { data } = await listChecklists(ticketId);
        const lists = (data && data.lists) || [];
        const items = (data && data.items) || [];
        const grouped = lists.map(l => ({ ...l, items: items.filter(it => it.checklistId === l.id) }));
        setChecklists(grouped);
      }
    } catch {}
  };

  const saveChecklistTitle = async (checklistId, value) => {
    if (!hasTicket) { toast.info("Crie o ticket antes de usar esta aba"); return; }
    const title = (value || "").trim();
    setEditingChecklistId(null);
    try {
      if (title) {
        await updateChecklist(checklistId, { title });
        const { data } = await listChecklists(ticketId);
        const lists = (data && data.lists) || [];
        const items = (data && data.items) || [];
        const grouped = lists.map(l => ({ ...l, items: items.filter(it => it.checklistId === l.id) }));
        setChecklists(grouped);
      }
    } catch {}
  };

  // Excluir ticket oficial diretamente do modal (somente quando há ticket)
  const handleDeleteTicket = async () => {
    if (!hasTicket) return;
    const confirmed = window.confirm("Excluir este ticket? Essa ação não pode ser desfeita.");
    if (!confirmed) return;
    setLoading(true);
    try {
      await api.delete(`/tickets/${ticketId}`);
      try { toast.success("Ticket excluído"); } catch {}
      onClose && onClose();
      onSaved && onSaved();
    } catch (e) {
      try { toast.error("Erro ao excluir o ticket"); } catch {}
    } finally {
      setLoading(false);
    }
  };

  // Drag & drop reorder para itens de checklist
  const onDragEnd = async (result) => {
    if (readOnly || !hasTicket) return; // bloqueia sem ticket ou somente leitura
    const { source, destination, draggableId } = result || {};
    if (!destination) return;
    if (source.droppableId !== destination.droppableId) return; // não permitir mover entre checklists diferentes neste MVP
    if (source.index === destination.index) return;
    const clId = Number(String(source.droppableId).replace("cl-", ""));
    const cl = (checklists || []).find((c) => c.id === clId);
    if (!cl) return;
    const items = Array.from(cl.items || []);
    const [moved] = items.splice(source.index, 1);
    items.splice(destination.index, 0, moved);
    // Atualiza estado otimista
    setChecklists((prev) => prev.map((c) => c.id !== clId ? c : { ...c, items }));
    // Persiste novas ordens (0..n)
    try {
      await Promise.all(items.map((it, idx) => updateChecklistItem(it.id, { order: idx })));
    } catch {}
  };

  const handleApplyTemplate = async (tplId) => {
    if (!tplId) return;
    if (!hasTicket) { toast.info("Crie o ticket antes de usar esta aba"); return; }
    try {
      await applyChecklistTemplate(ticketId, tplId);
      const { data } = await listChecklists(ticketId);
      const lists = (data && data.lists) || [];
      const items = (data && data.items) || [];
      const grouped = lists.map(l => ({ ...l, items: items.filter(it => it.checklistId === l.id) }));
      setChecklists(grouped);
      toast.success("Checklist criado a partir do modelo");
    } catch (e) {
      toast.error("Erro ao aplicar modelo");
    }
  };

  const isCategoryLocked = Boolean(persistedCategoryId);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      fullWidth
      classes={{ container: classes.dialogContainer, paper: classes.dialogPaper }}
    >
      {openAlert && (
        <ShowTicketOpen
          isOpen={openAlert}
          handleClose={handleCloseAlert}
          user={userTicketOpen}
          queue={queueTicketOpen}
        />
      )}
      <DialogTitle className={classes.dialogTitle}>
        Detalhes do Ticket
        {(() => {
          const firstTag = Array.isArray(ticketTags) && ticketTags.length > 0 ? ticketTags[0] : null;
          const isDone = workflowState === 'done';
          const isArchived = workflowState === 'archived';
          const stageLabel = isDone ? 'Concluído' : isArchived ? 'Arquivado' : (firstTag ? firstTag.name : 'Sem tag');
          const bg = isDone ? '#2e7d32' : isArchived ? '#616161' : (firstTag && firstTag.color ? firstTag.color : undefined);
          const style = bg ? { backgroundColor: bg, color: '#fff' } : {};
          return (
            <Chip size="small" style={{ marginLeft: 8, height: 24, fontWeight: 600, borderRadius: 12, ...style }} label={stageLabel} />
          );
        })()}
      </DialogTitle>
      <Tabs className={classes.tabsContainer} value={tab} onChange={(_, v) => setTab(v)} indicatorColor="primary" textColor="primary" variant="scrollable">
        <Tab label="Detalhes" />
        <Tab label="Comentários" />
        <Tab label="Checklist" />
      </Tabs>
      <DialogContent className={classes.dialogContent}>
        {advancedLocked && (
          <Box mb={1} className={classes.lockedBanner}>
            <Typography variant="body2" style={{ fontWeight: 500 }}>
              {bannerText} Campos e ações em laranja estão bloqueados.
            </Typography>
          </Box>
        )}
        {tab === 0 && (
          <Box className={classes.tabPanel}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                {(ticketId || (lockContact && (initialContact?.id || contactInfo))) ? (
                  <Box display="flex" justifyContent="center" alignItems="center" mt={0.5} mb={0.5}>
                    <Chip
                      className={classes.contactChip}
                      variant="default"
                      label={`${(contactInfo?.name || initialContact?.name || '')}${(contactInfo?.number || initialContact?.number) ? ` - ${(contactInfo?.number || initialContact?.number)}` : ''}`}
                      style={{ padding: '2px 8px' }}
                    />
                  </Box>
                ) : (
                  <Autocomplete
                    options={contactOptions}
                    loading={contactLoading}
                    getOptionLabel={(o) => (o?.name && o?.number) ? `${o.name} - ${o.number}` : (o?.name || o?.number || "")}
                    isOptionEqualToValue={(opt, val) => opt.id === val.id}
                    onChange={(e, nv) => setSelectedContact(nv || null)}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        className={classes.styledTextField}
                        label="Contato"
                        value={contactSearch}
                        onChange={(e) => setContactSearch(e.target.value)}
                        margin="dense"
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                            <>
                              {contactLoading ? <CircularProgress color="inherit" size={18} /> : null}
                              {params.InputProps.endAdornment}
                            </>
                          )
                        }}
                        helperText={selectedContact ? `${selectedContact.name || ''}${selectedContact.number ? ` - ${selectedContact.number}` : ''}` : "Digite ao menos 3 caracteres"}
                      />
                    )}
                  />
                )}
              </Grid>

              {/* Quando avançado estiver habilitado, manter layout original (com Categoria/Serviço) */}
              {!advancedLocked && (
                <>
                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl variant="outlined" fullWidth margin="dense" className={`${classes.outlinedControl} ${advancedLocked ? classes.lockedField : ''}`}>
                      <InputLabel id="category-label">Categoria</InputLabel>
                      <Select
                        labelId="category-label"
                        name="categoryId"
                        value={form.categoryId}
                        onChange={handleCategoryChange}
                        label="Categoria"
                        disabled={isCategoryLocked || readOnly || advancedLocked}
                      >
                        <MenuItem value=""><em>Nenhuma</em></MenuItem>
                        {(categories || []).map((cat) => (
                          <MenuItem key={cat.id} value={cat.id}>{cat.name}</MenuItem>
                        ))}
                      </Select>
                      {isCategoryLocked && (
                        <Typography variant="caption" color="textSecondary">Categoria não pode ser alterada após definida.</Typography>
                      )}
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl variant="outlined" fullWidth margin="dense" className={`${classes.outlinedControl} ${advancedLocked ? classes.lockedField : ''}`}>
                      <InputLabel id="service-label">Serviço</InputLabel>
                      <Select
                        labelId="service-label"
                        name="serviceId"
                        value={form.serviceId || ""}
                        onChange={handleChange}
                        label="Serviço"
                        disabled={readOnly || advancedLocked}
                      >
                        <MenuItem value=""><em>Nenhum</em></MenuItem>
                        {(services || []).map((s) => (
                          <MenuItem key={s.id} value={s.id}>{s.name}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <TextField
                      variant="outlined"
                      className={`${classes.styledTextField} ${advancedLocked ? classes.lockedField : ''}`}
                      name="dueDate"
                      type="datetime-local"
                      label="Vencimento"
                      value={form.dueDate}
                      onChange={handleChange}
                      margin="dense"
                      InputLabelProps={{ shrink: true }}
                      fullWidth
                      disabled={readOnly || advancedLocked}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={7}>
                    <TextField inputRef={subjectRef} variant="outlined" className={classes.styledTextField} name="subject" label="Assunto" value={form.subject} onChange={handleChange} fullWidth margin="dense" disabled={readOnly} />
                  </Grid>
                  <Grid item xs={12} sm={12} md={5}>
                    <Paper ref={priorityRef} className={`${classes.panelPaper} ${classes.priorityPaper} ${classes.denseLike} ${advancedLocked ? classes.lockedPanel : ''}`} elevation={0} style={priorityHeight ? { height: priorityHeight + 1 } : undefined}>
                      <Typography className={classes.panelLegend}>Prioridade</Typography>
                      <FormControl component="fieldset" margin="dense" className={classes.priorityControl}>
                        <RadioGroup row name="priority" value={String(form.priority)} onChange={(e) => setForm(prev => ({ ...prev, priority: e.target.value }))} className={classes.priorityGroup}>
                          {priorities.map((p) => {
                            const dotColor = p.value === 0 ? '#4caf50' : p.value === 1 ? '#ffb300' : '#f44336';
                            const labelNode = (
                              <Box display="flex" alignItems="center" style={{ whiteSpace: 'nowrap' }}>
                                <span style={{ width: 8, height: 8, borderRadius: '50%', background: dotColor, display: 'inline-block', marginRight: 6 }} />
                                {p.label}
                              </Box>
                            );
                            return (
                              <FormControlLabel
                                key={p.value}
                                value={String(p.value)}
                                control={<Radio color="primary" size="small" disabled={advancedLocked || readOnly} />}
                                label={labelNode}
                                style={{ marginRight: 8 }}
                              />
                            );
                          })}
                        </RadioGroup>
                      </FormControl>
                    </Paper>
                  </Grid>
                </>
              )}

              {/* Quando avançado estiver desativado, usar layout compacto 3 colunas: Vencimento, Assunto, Prioridade */}
              {advancedLocked && (
                <>
                  <Grid item xs={12} sm={6} md={3}>
                    <TextField
                      variant="outlined"
                      className={`${classes.styledTextField}`}
                      name="dueDate"
                      type="datetime-local"
                      label="Vencimento"
                      value={form.dueDate}
                      onChange={handleChange}
                      margin="dense"
                      InputLabelProps={{ shrink: true }}
                      fullWidth
                      disabled={readOnly}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={6}>
                    <TextField inputRef={subjectRef} variant="outlined" className={classes.styledTextField} name="subject" label="Assunto" value={form.subject} onChange={handleChange} fullWidth margin="dense" disabled={readOnly} />
                  </Grid>
                  <Grid item xs={12} sm={12} md={3}>
                    <Paper ref={priorityRef} className={`${classes.panelPaper} ${classes.priorityPaper} ${classes.denseLike}`} elevation={0} style={priorityHeight ? { height: priorityHeight + 1 } : undefined}>
                      <Typography className={classes.panelLegend}>Prioridade</Typography>
                      <FormControl component="fieldset" margin="dense" className={classes.priorityControl}>
                        <RadioGroup row name="priority" value={String(form.priority)} onChange={(e) => setForm(prev => ({ ...prev, priority: e.target.value }))} className={classes.priorityGroup}>
                          {priorities.map((p) => {
                            const dotColor = p.value === 0 ? '#4caf50' : p.value === 1 ? '#ffb300' : '#f44336';
                            const labelNode = (
                              <Box display="flex" alignItems="center" style={{ whiteSpace: 'nowrap' }}>
                                <span style={{ width: 8, height: 8, borderRadius: '50%', background: dotColor, display: 'inline-block', marginRight: 6 }} />
                                {p.label}
                              </Box>
                            );
                            return (
                              <FormControlLabel
                                key={p.value}
                                value={String(p.value)}
                                control={<Radio color="primary" size="small" disabled={readOnly} />}
                                label={labelNode}
                                style={{ marginRight: 8 }}
                              />
                            );
                          })}
                        </RadioGroup>
                      </FormControl>
                    </Paper>
                  </Grid>
                </>
              )}
            </Grid>
            <FormControl variant="outlined" fullWidth margin="dense" className={`${classes.outlinedControl} ${advancedLocked ? classes.lockedField : ''}`}>
              <InputLabel id="assignees-label">Responsáveis</InputLabel>
              <Select
                multiple
                labelId="assignees-label"
                label="Responsáveis"
                value={assignees}
                onChange={handleAssigneesChange}
                disabled={readOnly || advancedLocked}
                renderValue={(selected) => (
                  <Box display="flex" flexWrap="wrap">
                    {(selected || []).map((id) => {
                      const u = (allUsers || []).find((x) => x.id === id);
                      return (<Chip key={id} size="small" label={u ? (u.name || u.email) : id} style={{ marginRight: 4, marginTop: 2 }} />);
                    })}
                  </Box>
                )}
              >
                {(allUsers || []).map((u) => (
                  <MenuItem key={u.id} value={u.id}>{u.name || u.email || `Usuário ${u.id}`}</MenuItem>
                ))}
              </Select>
            </FormControl>
            <TextField
              variant="outlined"
              className={`${classes.styledTextField} ${classes.bigTextArea}`}
              name="description"
              value={form.description}
              onChange={handleChange}
              fullWidth
              margin="dense"
              multiline
              rows={6}
              disabled={readOnly}
            />
      {(fields || []).length > 0 && (
              <Grid container spacing={2} style={{ marginTop: 8 }}>
        {sortedFields.map((f) => {
                    const val = fieldValues[f.id] ?? (f.type === 'multiselect' ? [] : (f.type === 'bool' || f.type === 'boolean') ? false : '');
                    const isMultiline = MULTILINE_FIELD_NAMES.some((n) => String(f.name || '').toLowerCase() === String(n).toLowerCase());
                    const isLargeMultiline = LARGE_MULTILINE_FIELD_NAMES.some((n) => String(f.name || '').toLowerCase() === String(n).toLowerCase());
                    const keyNameLc = String(f.key || f.name || '').toLowerCase();
                    const isAmbienteUrls = keyNameLc.includes('ambiente/urls') || (keyNameLc.includes('ambiente') && keyNameLc.includes('url'));
                    const isLocalField = keyNameLc.includes('local');
                    const isSistemaModuloField = keyNameLc.includes('sistema') || keyNameLc.includes('modulo') || keyNameLc.includes('módulo');
                    const isUrgenciaField = keyNameLc.includes('urgenc');
                    const isNumeroSerieField = keyNameLc.includes('serial') || ((keyNameLc.includes('numero') || keyNameLc.includes('nº') || keyNameLc.includes('n°')) && (keyNameLc.includes('serie') || keyNameLc.includes('série')));
                    const isVersaoBuildField = keyNameLc.includes('versao') || keyNameLc.includes('versão') || keyNameLc.includes('build') || keyNameLc.includes('release');
                    const isAtivoEquipField = keyNameLc.includes('ativo') || keyNameLc.includes('equipamento') || keyNameLc.includes('asset') || keyNameLc.includes('device');
                    const isAmbienteField = keyNameLc.includes('ambiente');
                    const isTipoField = keyNameLc.includes('tipo') || keyNameLc.includes('type');
                    const isSeveridadeField = keyNameLc.includes('severidade') || keyNameLc.includes('severity');
                    const isImpactoField = keyNameLc.includes('impacto') || keyNameLc.includes('impact');
                    const isRadioLike = ['tipo','type','severidade','severity','ambiente','environment','criticidade','nivel','nível','level','impacto','impact']
                      .some(k => keyNameLc.includes(k)) && !isAmbienteUrls;
                    const commonProps = { key: f.id, fullWidth: true, margin: 'dense' };

                    // Colunas por tipo
                    const gridProps = isAmbienteUrls
                      ? { xs:12, sm:12, md:12 } // Força Ambiente/URLs a ocupar largura total
                      : (isAmbienteField || isTipoField || isSeveridadeField || isImpactoField)
                        ? { xs:12, sm:6, md:3 } // 1ª linha: 4 colunas de md:3 cada
                        : (isLocalField || isSistemaModuloField || isNumeroSerieField || isVersaoBuildField || isAtivoEquipField)
                          ? { xs:12, sm:6, md:4 } // 2ª linha: 3 colunas de md:4 cada (Local, Sistema/Módulo, Nº de série)
                          : isRadioLike
                          ? { xs:12, sm:6, md:4 }
                        : isMultiline
                          ? { xs:12, sm:12, md:12 }
                          : (f.type === 'multiselect')
                            ? { xs:12, sm:6, md:6 }
                            : (f.type === 'bool' || f.type === 'boolean')
                              ? { xs:12, sm:6, md:4 }
                              : { xs:12, sm:6, md:4 };

                    // Campo como RadioGroup vertical para tipo/severidade/ambiente e similares
                    if (isRadioLike && (f.options || []).length) {
                      return (
                        <Grid item key={f.id} {...gridProps}>
                          <Paper className={classes.panelPaper} elevation={0}>
                            <FormControl component="fieldset" fullWidth margin="dense">
                              <Typography variant="caption" color="textSecondary" style={{ marginLeft: 2 }}>
                                {`${f.name}${f.required ? ' *' : ''}`}
                              </Typography>
                              <RadioGroup
                                name={`field-${f.id}`}
                                value={String(val ?? '')}
                                onChange={(e) => handleFieldValueChange(f.id, e.target.value)}
                              >
                                {(f.options || []).map((opt, idx) => {
                                  const value = String(typeof opt === 'object' && opt !== null ? (opt.value ?? opt.label ?? '') : opt);
                                  const rawLabel = String(typeof opt === 'object' && opt !== null ? (opt.label ?? opt.value ?? '') : opt);
                                  const displayLabel = isSeveridadeField
                                    ? (rawLabel || '').trim().replace(/^s\s*(\d+)$/i, 'Nível $1')
                                    : rawLabel;
                                  return (
                                    <FormControlLabel key={idx} value={value} control={<Radio color="primary" size="small" />} label={displayLabel} />
                                  );
                                })}
                              </RadioGroup>
                              {!!errors[f.id] && <Typography style={{ color: '#f44336' }} variant="caption">{errors[f.id]}</Typography>}
                            </FormControl>
                          </Paper>
                        </Grid>
                      );
                    }

                    if (f.type === 'select') {
                      return (
                        <Grid item key={f.id} {...gridProps}>
                          <TextField
                            variant="outlined"
                            className={classes.styledTextField}
                            {...commonProps}
                            select
                            label={`${f.name}${f.required ? ' *' : ''}`}
                            error={Boolean(errors[f.id])}
                            helperText={errors[f.id] || ''}
                            value={val}
                            onChange={(e) => handleFieldValueChange(f.id, e.target.value)}
                            disabled={readOnly || advancedLocked}
                          >
                            {(f.options || []).map((opt, idx) => {
                              const value = String(typeof opt === 'object' && opt !== null ? (opt.value ?? opt.label ?? '') : opt);
                              const rawLabel = String(typeof opt === 'object' && opt !== null ? (opt.label ?? opt.value ?? '') : opt);
                              const displayLabel = isSeveridadeField
                                ? (rawLabel || '').trim().replace(/^s\s*(\d+)$/i, 'Nível $1')
                                : rawLabel;
                              return (
                                <MenuItem key={idx} value={value}>{displayLabel}</MenuItem>
                              );
                            })}
                          </TextField>
                        </Grid>
                      );
                    }
                    if (f.type === 'multiselect') {
                      return (
                        <Grid item key={f.id} {...gridProps}>
                          <FormControl variant="outlined" fullWidth margin="dense" className={classes.outlinedControl}>
                            <InputLabel id={`field-${f.id}-label`}>{`${f.name}${f.required ? ' *' : ''}`}</InputLabel>
                            <Select
                              labelId={`field-${f.id}-label`}
                              multiple
                              value={Array.isArray(val) ? val : []}
                              onChange={(e) => handleFieldValueChange(f.id, e.target.value)}
                              disabled={readOnly || advancedLocked}
                            >
                              {(f.options || []).map((opt, idx) => {
                                const value = String(typeof opt === 'object' && opt !== null ? (opt.value ?? opt.label ?? '') : opt);
                                const rawLabel = String(typeof opt === 'object' && opt !== null ? (opt.label ?? opt.value ?? '') : opt);
                                const displayLabel = isSeveridadeField
                                  ? (rawLabel || '').trim().replace(/^s\s*(\d+)$/i, 'Nível $1')
                                  : rawLabel;
                                return <MenuItem key={idx} value={value}>{displayLabel}</MenuItem>;
                              })}
                            </Select>
                            {!!errors[f.id] && <Typography style={{ color: '#f44336' }} variant="caption">{errors[f.id]}</Typography>}
                          </FormControl>
                        </Grid>
                      );
                    }
                    if (f.type === 'date') {
                      return (
                        <Grid item key={f.id} {...gridProps}>
                          <TextField
                            variant="outlined"
                            className={classes.styledTextField}
                            {...commonProps}
                            type="date"
                            label={`${f.name}${f.required ? ' *' : ''}`}
                            error={Boolean(errors[f.id])}
                            helperText={errors[f.id] || ''}
                            value={val}
                            onChange={(e) => handleFieldValueChange(f.id, e.target.value)}
                            InputLabelProps={{ shrink: true }}
                            disabled={readOnly || advancedLocked}
                          />
                        </Grid>
                      );
                    }
                    if (f.type === 'number') {
                      return (
                        <Grid item key={f.id} {...gridProps}>
                          <TextField
                            variant="outlined"
                            className={classes.styledTextField}
                            {...commonProps}
                            type="number"
                            label={`${f.name}${f.required ? ' *' : ''}`}
                            error={Boolean(errors[f.id])}
                            helperText={errors[f.id] || ''}
                            value={val}
                            onChange={(e) => handleFieldValueChange(f.id, e.target.value)}
                            disabled={readOnly || advancedLocked}
                          />
                        </Grid>
                      );
                    }
                    if (f.type === 'bool' || f.type === 'boolean') {
                      return (
                        <Grid item key={f.id} {...gridProps}>
                          <FormControl component="fieldset" fullWidth margin="dense">
                            <FormControlLabel
                              control={
                                <Checkbox
                                  color="primary"
                                  checked={Boolean(val)}
                                  onChange={(e) => handleFieldValueChange(f.id, e.target.checked)}
                                  disabled={readOnly || advancedLocked}
                                />
                              }
                              label={`${f.name}${f.required ? ' *' : ''}`}
                            />
                            {!!errors[f.id] && (
                              <Typography style={{ color: '#f44336', marginLeft: 8 }} variant="caption">{errors[f.id]}</Typography>
                            )}
                          </FormControl>
                        </Grid>
                      );
                    }
                    // texto / padrão
                    return (
                      <Grid item key={f.id} {...gridProps}>
                        <TextField
                          variant="outlined"
                          className={classes.styledTextField}
                          {...commonProps}
                          label={`${f.name}${f.required ? ' *' : ''}`}
                          error={Boolean(errors[f.id])}
                          helperText={errors[f.id] || ''}
                          value={val}
                          onChange={(e) => handleFieldValueChange(f.id, e.target.value)}
                          multiline={isMultiline}
                          rows={isLargeMultiline ? 6 : isMultiline ? 3 : undefined}
                          disabled={readOnly || advancedLocked}
                        />
                      </Grid>
                    );
                })}
              </Grid>
            )}
            {customFields.length > 0 && (
              <Box mt={2}>
                <Paper className={`${classes.panelPaper} ${advancedLocked ? classes.lockedPanel : ''}`} elevation={0}>
                  <Typography className={classes.panelLegend}>Campos Personalizados</Typography>
                  <Box pt={2} pb={1}>
                    {(() => {
                      const textTypes = new Set(['short_text','long_text']);
                      const tFields = customFields.filter(cf => textTypes.has(cf.type));
                      const oFields = customFields.filter(cf => !textTypes.has(cf.type));
                      return (
                        <>
                          {tFields.length > 0 && (
                            <Grid container spacing={2}>
                              {tFields.map(cf => (
                                <Grid item xs={12} key={cf.id}>
                                  {renderCustomField(cf)}
                                </Grid>
                              ))}
                            </Grid>
                          )}
                          {oFields.length > 0 && (
                            <Box mt={tFields.length > 0 ? 1 : 0}>
                              <Grid container spacing={2}>
                                {oFields.map(cf => (
                                  <Grid item xs={12} sm={6} key={cf.id}>
                                    {renderCustomField(cf)}
                                  </Grid>
                                ))}
                              </Grid>
                            </Box>
                          )}
                        </>
                      );
                    })()}
                  </Box>
                </Paper>
              </Box>
            )}
          </Box>
        )}

        {tab === 1 && (
          <Box className={classes.tabPanel}>
            {!hasTicket && (
              <Box mb={1} className={classes.lockedBanner}>
                <Typography variant="body2">Disponível após criar/salvar o ticket.</Typography>
              </Box>
            )}
            <div className={`${classes.commentNewContainer} ${advancedLocked ? classes.lockedPanel : ''}`}>
                <TextField
                  variant="outlined"
                  className={`${classes.styledTextField} ${advancedLocked ? classes.lockedField : ''}`}
                  label="Novo comentário"
                  value={newComment}
                  onChange={(e) => setNewComment(e.target.value)}
                  margin="dense"
                  multiline
                  rows={3}
                  fullWidth
                  disabled={readOnly || advancedLocked || !hasTicket}
                />
                <div className={classes.commentNewActions}>
                  <Box display="flex" alignItems="center" gridGap={8}>
                    <Checkbox size="small" checked={newCommentInternal} onChange={(e) => setNewCommentInternal(e.target.checked)} color="primary" disabled={readOnly || advancedLocked || !hasTicket} />
                    <Typography variant="caption">Nota interna</Typography>
                  </Box>
                  <Button variant="contained" color="primary" onClick={submitComment} disabled={readOnly || advancedLocked || !hasTicket || !newComment.trim()}>Adicionar</Button>
                </div>
              </div>
            {loadingComments && (
              <Typography variant="body2" color="textSecondary">Carregando...</Typography>
            )}
            {!loadingComments && comments.length === 0 && (
              <Typography variant="body2" color="textSecondary">Nenhum comentário.</Typography>
            )}
            <div className={classes.commentList}>
              {!loadingComments && comments.map((c) => {
                const isOwner = (c.user && c.user.id === (user && user.id)) || (user && user.profile === 'admin');
                const initials = (c.user && (c.user.name || c.user.email) ? (c.user.name || c.user.email) : '?')
                  .split(/\s+/).map(p => p.charAt(0)).join('').substring(0,2).toUpperCase();
                const edited = c.updatedAt && c.createdAt && String(c.updatedAt) !== String(c.createdAt);
                const cardCls = `${classes.commentCard} ${c.isInternal ? classes.commentCardInternal : ''}`;
                if (editingCommentId === c.id) {
                  return (
                    <div key={c.id} className={cardCls}>
                      <div className={classes.commentAvatar}>{initials}</div>
                      <div className={classes.commentBody}>
                        <div className={classes.commentHeader}>
                          <span className={classes.commentName}>{(c.user && (c.user.name || c.user.email)) || 'Usuário desconhecido'}</span>
                          {c.isInternal && <Chip size="small" label="NOTA INTERNA" className={classes.commentInternalChip} />}
                          {edited && <span className={classes.commentEdited}>EDITADO</span>}
                          <span className={classes.commentTimestamp}>{c.createdAt ? new Date(c.createdAt).toLocaleString() : ''}</span>
                        </div>
                        <div className={classes.commentEditArea}>
                          <TextField
                            variant="outlined"
                            className={classes.styledTextField}
                            value={editingCommentText}
                            onChange={(e) => setEditingCommentText(e.target.value)}
                            margin="dense"
                            multiline
                            rows={3}
                            fullWidth
                          />
                          <Box display="flex" alignItems="center" gridGap={8} style={{ marginTop: 8 }}>
                            <Checkbox
                              size="small"
                              checked={editingCommentInternal}
                              onChange={(e) => setEditingCommentInternal(e.target.checked)}
                              color="primary"
                            />
                            <Typography variant="caption">Nota interna</Typography>
                          </Box>
                          <Box display="flex" gridGap={8} style={{ marginTop: 8 }}>
                            <Button size="small" color="primary" variant="contained" onClick={saveEditComment} disabled={!editingCommentText.trim()}>Salvar</Button>
                            <Button size="small" onClick={cancelEditComment}>Cancelar</Button>
                          </Box>
                        </div>
                      </div>
                      <div className={classes.commentActions}>
                        <IconButton size="small" onClick={() => removeCommentById(c.id)}>
                          <DeleteIcon style={{ fontSize: 22 }} />
                        </IconButton>
                      </div>
                    </div>
                  );
                }
                return (
                  <div key={c.id} className={cardCls}>
                    <div className={classes.commentAvatar}>{initials}</div>
                    <div className={classes.commentBody}>
                      <div className={classes.commentHeader}>
                        <span className={classes.commentName}>{(c.user && (c.user.name || c.user.email)) || 'Usuário desconhecido'}</span>
                        {c.isInternal && <Chip size="small" label="NOTA INTERNA" className={classes.commentInternalChip} />}
                        {edited && <span className={classes.commentEdited}>EDITADO</span>}
                        <span className={classes.commentTimestamp}>{c.createdAt ? new Date(c.createdAt).toLocaleString() : ''}</span>
                      </div>
                      <div className={classes.commentMessage}>{c.message || '(sem texto)'}</div>
                    </div>
                    {isOwner && !readOnly && !advancedLocked && hasTicket && (
                      <div className={classes.commentActions}>
                        <IconButton size="small" onClick={() => beginEditComment(c)}>
                          <EditIcon style={{ fontSize: 22 }} />
                        </IconButton>
                        <IconButton size="small" onClick={() => removeCommentById(c.id)}>
                          <DeleteIcon style={{ fontSize: 22 }} />
                        </IconButton>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </Box>
        )}

        {tab === 2 && (
          <Box className={classes.tabPanel}>
            {!hasTicket && (
              <Box mb={1} className={classes.lockedBanner}>
                <Typography variant="body2">Disponível após criar/salvar o ticket.</Typography>
              </Box>
            )}
            <Paper className={classes.panelPaper} elevation={0}>
      {/* Novo layout de controles: Aplicar modelo -> OU -> Novo checklist + Criar */}
      <Grid container spacing={1} alignItems="center" wrap="wrap" style={{ paddingTop: 4, paddingBottom: 4 }}>
        <Grid item xs={12} sm={5} md={4} lg={3}>
            <TextField
            variant="outlined"
              className={`${classes.styledTextField} ${advancedLocked ? classes.lockedField : ''}`}
            select
            label="Aplicar modelo"
            value=""
            onChange={(e) => handleApplyTemplate(e.target.value)}
            margin="dense"
            fullWidth
            disabled={readOnly || advancedLocked || !hasTicket}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start" style={{ marginLeft: 4 }}>
                  {/* Ícone simbólico para modelo */}
                  <span role="img" aria-label="modelo">📋</span>
                </InputAdornment>
              )
            }}
            style={{ minWidth: 220 }}
          >
            <MenuItem value="">Selecionar modelo…</MenuItem>
            {(templates || []).map(t => (
              <MenuItem key={t.id} value={t.id}>{t.name}</MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid item xs={12} sm={2} md={1} lg={1} style={{ display: 'flex', justifyContent: 'center' }}>
          <Chip label="ou" size="small" style={{ fontWeight: 600, opacity: 0.8, alignSelf: 'center' }} />
        </Grid>
        <Grid item xs={12} sm={5} md={5} lg={5}>
          <TextField
            variant="outlined"
            className={`${classes.styledTextField} ${advancedLocked ? classes.lockedField : ''}`}
            label="Novo checklist"
            value={newChecklistTitle}
            onChange={(e) => setNewChecklistTitle(e.target.value)}
            margin="dense"
            fullWidth
            onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); if (newChecklistTitle.trim()) createNewChecklist(); }} }
            disabled={readOnly || advancedLocked || !hasTicket}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={2} lg={2}>
          <Button
            variant="contained"
            color="primary"
            onClick={createNewChecklist}
            style={{ marginTop: 4, marginBottom: 4 }}
            fullWidth
            disabled={readOnly || advancedLocked || !hasTicket || !newChecklistTitle.trim()}
          >
            Criar
          </Button>
        </Grid>
      </Grid>
    </Paper>
    <Box mt={1}><Divider /></Box>
    {loadingChecklists && <Typography>Carregando...</Typography>}
  {!loadingChecklists && (
        <DragDropContext onDragEnd={onDragEnd}>
        {(checklists || []).map((cl) => (
          <Box key={cl.id} mt={2}>
            <Box className={headerClasses.checklistHeader}>
              <Box display="flex" alignItems="center" gridGap={8}>
                {editingChecklistId === cl.id ? (
                  <TextField
                    variant="outlined"
                    size="small"
                    className={classes.styledTextField}
                    value={editingChecklistTitle}
                    autoFocus
                    onChange={(e) => setEditingChecklistTitle(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') { e.preventDefault(); e.currentTarget.blur(); }
                     
                      if (e.key === 'Escape') { setEditingChecklistId(null); }
                    }}
                    onBlur={(e) => saveChecklistTitle(cl.id, e.target.value)}
                    style={{ minWidth:
 220 }}
                  />
                ) : (
                  <Box display="flex" alignItems="center" gridGap={6}>
                    <Typography
                      variant="subtitle1"
                      onClick={() => { if (!readOnly) { setEditingChecklistId(cl.id); setEditingChecklistTitle(cl.title || ""); } }}
                      className={headerClasses.checklistHeaderTitle}
                      style={{ cursor: 'pointer' }}
                      title="Clique para renomear"
                    >
                      {cl.title || "(sem título)"}
                    </Typography>
                    {!readOnly && !advancedLocked && hasTicket && (
                      <Tooltip title="Renomear checklist">
                        <IconButton size="small" color="inherit" onClick={() => { setEditingChecklistId(cl.id); setEditingChecklistTitle(cl.title || ""); }}>
                          <EditIcon fontSize="small" style={{ color: 'inherit' }} />
                        </IconButton>
                      </Tooltip>
                    )}
                  </Box>
                )}
                {cl.responsibleUserId ? (
                  <Chip size="small" className={headerClasses.checklistHeaderChip} label={`Resp.: ${(allUsers.find(u=>u.id===cl.responsibleUserId)?.name) || cl.responsibleUserId}`} />
                ) : null}
              </Box>
              {!readOnly && !advancedLocked && hasTicket && (
                <IconButton onClick={() => removeChecklistById(cl.id)} size="small" color="inherit">
                  <DeleteIcon style={{ color: 'inherit' }} />
                </IconButton>
              )}
            </Box>
            <Droppable droppableId={`cl-${cl.id}`}>
              {(provided) => (
                <List dense ref={provided.innerRef} {...provided.droppableProps}>
                  {(cl.items || []).map((it, idx) => (
                    <Draggable key={it.id} draggableId={`cli-${it.id}`} index={idx} isDragDisabled={readOnly || advancedLocked || !hasTicket}>
                      {(prov) => (
                        <ListItem
                          ref={prov.innerRef}
                          {...prov.draggableProps}
                          {...prov.dragHandleProps}
                          alignItems="flex-start"
                          style={{
                            paddingTop: 10,
                            paddingBottom: 10,
                            ...(it.done
                              ? {
                                  backgroundColor: isDark ? 'rgba(46,125,50,0.18)' : '#e8f5e9',
                                  border: isDark ? '1px solid rgba(129,199,132,0.35)' : '1px solid #c8e6c9',
                                  borderRadius: 10,
                                }
                              : {}),
                          }}
                        >
                          <Box display="flex" flexDirection="column" flex={1} pr={1}>
                            <Box display="flex" alignItems="center" justifyContent="space-between" gridGap={8}>
                              <Box>
                                {editingItemId === it.id ? (
                                  <TextField
                                    variant="outlined"
                                    size="small"
                                    className={classes.styledTextField}
                                    value={editingItemTitle}
                                    autoFocus
                                    onChange={(e) => setEditingItemTitle(e.target.value)}
                                    onKeyDown={(e) => {
                                      if (e.key === 'Enter') { e.preventDefault(); e.currentTarget.blur(); }
                                      if (e.key === 'Escape') { setEditingItemId(null); }
                                    }}
                                    onBlur={(e) => saveItemTitle(it.id, e.target.value)}
                                    style={{ minWidth: 220 }}
                                  />
                                ) : (
                                  <Box display="flex" alignItems="center" gridGap={6}>
                                    <Typography
                                      variant="subtitle2"
                                      style={{ fontWeight: 600, opacity: it.done ? 0.7 : 1 }}
                                      title={it.done ? 'Item concluído — reabra para editar' : ''}
                                    >
                                      {it.title}
                                    </Typography>
                                    {!it.done && !readOnly && hasTicket && (
                                      <Tooltip title="Editar título">
                                        <IconButton size="small" onClick={() => { setEditingItemId(it.id); setEditingItemTitle(it.title || ""); }}>
                                          <EditIcon fontSize="small" />
                                        </IconButton>
                                      </Tooltip>
                                    )}
                                    {!readOnly && !it.done && hasTicket && !it.description && !addingDescriptionFor[it.id] && (
                                      <Typography
                                        variant="caption"
                                        style={{ cursor: 'pointer', color: '#1976d2', fontWeight: 500, marginLeft: 4 }}
                                        onClick={() => setAddingDescriptionFor(prev => ({ ...prev, [it.id]: true }))}
                                      >
                                        + Descrição
                                      </Typography>
                                    )}
                                  </Box>
                                )}
                                {it.completedAt ? (
                                  <Typography variant="caption" color="textSecondary">
                                    {`Concluído em ${new Date(it.completedAt).toLocaleDateString()}`}
                                  </Typography>
                                ) : null}
                              </Box>
                              <TextField
                                variant="outlined"
                                className={`${classes.styledTextField} ${advancedLocked ? classes.lockedField : ''}`}
                                type="date"
                                label="Prazo"
                                value={it.dueDate ? String(it.dueDate).slice(0, 10) : ""}
                                onChange={(e) => updateItemDueDate(it, e.target.value)}
                                InputLabelProps={{ shrink: true }}
                                style={{ width: 160 }}
                                disabled={readOnly || advancedLocked || !hasTicket}
                              />
                            </Box>
                            <Box mt={1}>
                              {(it.description || addingDescriptionFor[it.id]) && (
                                <Box position="relative">
                                  <TextField
                                    variant="outlined"
                                    className={`${classes.styledTextField} ${advancedLocked ? classes.lockedField : ''}`}
                                    label="Descrição"
                                    defaultValue={it.description || ""}
                                    onBlur={async (e) => {
                                      if (readOnly || advancedLocked || !hasTicket) return;
                                      const raw = e.target.value || "";
                                      const trimmed = raw.trim();
                                      const payload = trimmed ? trimmed : null;
                                      try {
                                        if (payload !== (it.description || null)) {
                                          await updateChecklistItem(it.id, { description: payload });
                                          try {
                                            const { data } = await listChecklists(ticketId);
                                            const lists = (data && data.lists) || [];
                                            const items = (data && data.items) || [];
                                            const grouped = lists.map(l => ({ ...l, items: items.filter(ci => ci.checklistId === l.id) }));
                                            setChecklists(grouped);
                                          } catch {}
                                        }
                                      } catch {}
                                      if (!payload) {
                                        setAddingDescriptionFor(prev => { const c = { ...prev }; delete c[it.id]; return c; });
                                      }
                                    }}
                                    multiline
                                    rows={4}
                                    inputProps={{ style: { resize: 'vertical' } }}
                                    fullWidth
                                    disabled={readOnly || !hasTicket}
                                  />
                                  {!readOnly && !advancedLocked && hasTicket && (it.description || addingDescriptionFor[it.id]) && (
                                    <Tooltip title="Remover descrição">
                                      <IconButton size="small" style={{ position:'absolute', top:4, right:4 }} onClick={async ()=> {
                                        try {
                                          await updateChecklistItem(it.id, { description: null });
                                          setAddingDescriptionFor(prev => { const c = { ...prev }; delete c[it.id]; return c; });
                                          try {
                                            const { data } = await listChecklists(ticketId);
                                            const lists = (data && data.lists) || [];
                                            const items = (data && data.items) || [];
                                            const grouped = lists.map(l => ({ ...l, items: items.filter(ci => ci.checklistId === l.id) }));
                                            setChecklists(grouped);
                                          } catch {}
                                        } catch {}
                                      }}>
                                        <DeleteIcon fontSize="small" />
                                      </IconButton>
                                    </Tooltip>
                                  )}
                                </Box>
                              )}
                            </Box>
                          </Box>
                          <Box display="flex" alignItems="center" pl={1}>
                            {!readOnly && !advancedLocked && hasTicket && (
                              <>
                                <Tooltip title={it.done ? "Marcar como pendente" : "Marcar como concluído"}>
                                  <IconButton edge="end" onClick={() => toggleItemDone(it)} style={it.done ? { color: "#4caf50" } : undefined}>
                                    {it.done ? <CheckCircle /> : <AccessTime />}
                                  </IconButton>
                                </Tooltip>
                                <IconButton edge="end" onClick={() => removeItem(it.id)}>
                                  <DeleteIcon />
                                </IconButton>
                              </>
                            )}
                          </Box>
                        </ListItem>
                      )}
                    </Draggable>
                  )).reduce((acc, node, idx, arr) => {
                            acc.push(node);
                            if (idx < arr.length - 1) {
                              acc.push(
                                <Divider
                                  key={`div-${cl.id}-${idx}`}
                                  component="li"
                                  style={{ margin: '10px 0', marginLeft: 0 }}
                                />
                              );
                            }
                            return acc;
                          }, [])}
                          {provided.placeholder}
                          {(cl.items || []).length > 0 && (
                            <Divider component="li" style={{ margin: '12px 0', marginLeft: 0 }} />
                          )}
                          {!readOnly && (
                            <ListItem style={{ display: 'block', paddingTop: 10, paddingBottom: 10 }} className={advancedLocked ? classes.lockedPanel : ''}>
                              <TextField
                                variant="outlined"
                                className={`${classes.styledTextField} ${advancedLocked ? classes.lockedField : ''}`}
                                placeholder="Título do novo item"
                                fullWidth
                                disabled={advancedLocked || !hasTicket}
                                onKeyDown={async (e) => {
                                  if (advancedLocked || !hasTicket) return;
                                  if (e.key === "Enter") {
                                    const v = e.target.value;
                                    e.preventDefault();
                                    if (v && v.trim()) {
                                      await addItemToChecklist(cl.id, v.trim());
                                      e.target.value = "";
                                    }
                                  }
                                }}
                                style={{ marginBottom: 8 }}
                              />
                              <TextField
                                variant="outlined"
                                className={`${classes.styledTextField} ${advancedLocked ? classes.lockedField : ''}`}
                                placeholder="Descrição do novo item (opcional)"
                                fullWidth
                                multiline
                                rows={4}
                                inputProps={{ style: { resize: 'vertical' } }}
                                disabled={advancedLocked || !hasTicket}
                                onKeyDown={async (e) => {
                                  if (advancedLocked || !hasTicket) return;
                                  if (e.key === "Enter" && (e.ctrlKey || e.metaKey)) {
                                    const descInput = e.target;
                                    const container = descInput.parentElement;
                                    const inputs = container.querySelectorAll('input, textarea');
                                    const titleInput = inputs[0];
                                    const title = titleInput?.value?.trim();
                                    const description = descInput?.value?.trim();
                                    e.preventDefault();
                                    if (title) {
                                      await addChecklistItem(cl.id, title, description || undefined);
                                      if (titleInput) titleInput.value = "";
                                      if (descInput) descInput.value = "";
                                      const { data } = await listChecklists(ticketId);
                                      const lists = (data && data.lists) || [];
                                      const items = (data && data.items) || [];
                                      const grouped = lists.map(l => ({ ...l, items: items.filter(it => it.checklistId === l.id) }));
                                      setChecklists(grouped);
                                    }
                                  }
                                }}
                                helperText="Dica: Ctrl+Enter para criar com título e descrição"
                              />
                            </ListItem>
                          )}
                        </List>
                      )}
                    </Droppable>
                  </Box>
                ))}
              </DragDropContext>
            )}
            {!loadingChecklists && (checklists || []).length === 0 && (
              <Box flex={1} display="flex" alignItems="center" justifyContent="center" py={4}>
                <Typography variant="body2" color="textSecondary" align="center">Nenhum checklist.</Typography>
              </Box>
            )}
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Box display="flex" alignItems="center" justifyContent="space-between" width="100%">
          <Box>
            {hasTicket && user?.profile === 'admin' && (
              <Button
                onClick={handleDeleteTicket}
                variant="contained"
                startIcon={<DeleteIcon />}
                disabled={loading}
                style={{
                  background: theme.palette.error.main,
                  color: theme.palette.getContrastText(theme.palette.error.main)
                }}
              >
                Excluir ticket
              </Button>
            )}
          </Box>
          <Box>
            <Button onClick={onClose} disabled={loading}>Fechar</Button>
            {tab === 0 && (
              <Button color="primary" variant="contained" onClick={handleSave} disabled={loading || Object.keys(errors).length > 0}>Salvar</Button>
            )}
          </Box>
        </Box>
        {/* Responsáveis são salvos automaticamente junto com os detalhes */}
      </DialogActions>
    </Dialog>
  );
};

export default TicketDetailsModal;
